import { Box } from "@mui/material";

/** Este Componente es el tipico recuadro ovalado gris que contiene información en varias partes del sistema.
 * 
 * Probarlo en conjunto con el componente InfoRow para mostrar la información de manera ordenada y clara.
*/
export const CustomInfoContainer = ({ children, sx }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            columnGap={1}
            sx={{
                backgroundColor: '#EBEBEB',
                borderRadius: '12px',
                p: 1.5,
                whiteSpace: 'nowrap',
                ...sx
            }}
        >
            {children}
        </Box>
    )
};